import cn from "classnames";
import DynamicPicture from "@/components/common/DynamicPicture";
import HeaderVariant1 from "@/components/site-builder/BaseModule/HeaderVariant1";
import HorizontalHeader from "@/components/site-builder/BaseModule/HorizontalHeader";
import Wrapper from "@/components/site-builder/BaseModule/Wrapper";
import {
  SiteBuilderModuleHeaderAlignment,
  SiteBuilderModuleHeaderPosition,
  SiteBuilderModuleLayoutSize,
} from "@/constants/site-builder";
import { getSizeByPredefinedSize } from "@/utils/style/getSizeByPredefinedSize";
import type { HeroModuleType } from "../types";
import s from "./HeroVariant4.module.scss";

export interface HeroVariant4Props {
  module: HeroModuleType;
}

export default function HeroVariant4(props: HeroVariant4Props) {
  const { module } = props;
  const {
    style: {
      display: { layoutSize, headerAlignment, headerPosition },
    },
    settings: {
      container: { minHeight },
    },
    body: { image, mediaDisplayVariant },
  } = module;

  const tileStyle = {
    minHeight: getSizeByPredefinedSize(minHeight),
  };
  const tileClassName = cn(s.tile, {
    "flex-center": headerAlignment === SiteBuilderModuleHeaderAlignment.Middle,
  });
  const mediaContentClassName = cn(s.mediaContent, {
    [s.alignRight]: headerPosition === SiteBuilderModuleHeaderPosition.Right,
  });

  return (
    <Wrapper module={module}>
      <HorizontalHeader
        module={module}
        headerContent={
          <div className={tileClassName} style={tileStyle}>
            <HeaderVariant1 module={module} />
          </div>
        }
        fluid={layoutSize === SiteBuilderModuleLayoutSize.FullScreen}
        stretchColumns
        collapseTabletMobileGap
      >
        <div className={mediaContentClassName}>
          <DynamicPicture image={image} option={mediaDisplayVariant} />
        </div>
      </HorizontalHeader>
    </Wrapper>
  );
}
